import { render } from "./LinesBI.vue?vue&type=template&id=2ee6bf52&ts=true"
import script from "./LinesBI.vue?vue&type=script&lang=tsx"
export * from "./LinesBI.vue?vue&type=script&lang=tsx"

import "./LinesBI.vue?vue&type=style&index=0&id=2ee6bf52&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__